/* eslint-disable import/prefer-default-export */
export const dayMapMondayFirst = {
  mon: 0,
  tue: 1,
  wed: 2,
  thu: 3,
  fri: 4,
  sat: 5,
  sun: 6,
};
